export const extractAllDynamicKeys = (item: any) => {
    return Object.keys(item).filter((key) =>
        item[key]?.oldValue__ !== undefined && item[key]?.currentValue__ !== undefined
    );
};

export const attributeNameForHistoryLabel = (historyKey: string) => {
    const pos = historyKey.indexOf('[');
    if (pos > 0) {
        return historyKey.substring(0, pos);
    }
    return historyKey;
};
